import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit,
  ViewEncapsulation,
} from '@angular/core';
import { NodePartner, Partner } from '@madeinlune/massaud-types';
import { DrupalTerm } from '@madeinlune/drupal-types';
import { PartnersComponent } from '../partners/partners.component';
import { NgIf } from '@angular/common';
import { RouterStaticLinkDirective } from '@nx-massaud/routing/link';

@Component({
  selector: 'msd-det-ui-features',
  standalone: true,
  template: `
    <!--<ng-container *ngIf="subTypologie">
      <p [innerHTML]="subTypologie.title" class="tag"></p>
    </ng-container>-->
    <ng-container *ngIf="partners">
      <msd-det-ui-partners
        [partners]="partners"
        class="tag"
      ></msd-det-ui-partners>
    </ng-container>
    <ng-container *ngIf="year">
      <p [innerHTML]="year" class="tag year"></p>
    </ng-container>
    <ng-container *ngIf="typologie">
      <a
        [innerHTML]="typologie.title"
        [routerStaticLink]="typologie.path"
        class="tag"
      ></a>
    </ng-container>
  `,
  styleUrls: ['./features.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [PartnersComponent, NgIf, RouterStaticLinkDirective],
})
export class FeaturesComponent {
  @Input()
  partners: NodePartner[] | undefined;

  @Input()
  year!: string | null;

  @Input()
  typologie: DrupalTerm | undefined;

  @Input()
  subTypologie: DrupalTerm | undefined;
}
